import React from 'react';
import { BodyText, BoldBodyText, Grid } from 'ui-toolkit/components';
import { ILabelValue } from '../../../../../ui-toolkit/utilities/ILabelValue';

export interface ILabelValueViewerProps extends ILabelValue<string, string | number> {
  templateColumns?: string;
}
// simple and consistent way to display key value pairs if the value is easily converted to text
export const LabelValueViewer: React.FC<ILabelValueViewerProps> = ({ label, value, templateColumns }) => (
  <Grid templateColumns={templateColumns || '1fr 4fr'}>
    <BoldBodyText>{label}:</BoldBodyText>
    <BodyText>{value}</BodyText>
  </Grid>
);

// a more general component
export const KeyObjectViewer: React.FC<{ label: string; templateColumns?: string; children: React.ReactNode }> = ({
  label,
  templateColumns,
  children,
}) => (
  <Grid templateColumns={templateColumns || '1fr 4fr'}>
    <BoldBodyText>{label}:</BoldBodyText>
    {children}
  </Grid>
);
